import { useState, useEffect } from "react";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
} from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { UserRound } from "lucide-react";

export default function ProfileDrawer({ open, onOpenChange, profile, onSave }) {
  const [form, setForm] = useState(profile);

  useEffect(() => {
    if (open) setForm(profile);
  }, [open, profile]);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = () => {
    if (!form.name || !form.email) {
      toast.error("Fyll i minst namn och e-post.");
      return;
    }
    onSave(form);
    toast.success("Profil sparad i din webbläsare.");
    onOpenChange(false);
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="jk-scroll w-full overflow-y-auto sm:max-w-md" data-testid="profile-drawer">
        <SheetHeader className="text-left">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-emerald-100 text-emerald-700">
              <UserRound className="h-4 w-4" />
            </span>
            <div>
              <SheetTitle className="font-display">Din profil</SheetTitle>
              <SheetDescription className="text-xs">
                Sparas lokalt i din webbläsare. Används för att skräddarsy AI-mailen.
              </SheetDescription>
            </div>
          </div>
        </SheetHeader>

        <div className="mt-6 space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="pf-name">Namn *</Label>
            <Input id="pf-name" data-testid="profile-name-input" value={form.name} onChange={set("name")} placeholder="Anna Andersson" />
          </div>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div className="space-y-1.5">
              <Label htmlFor="pf-email">E-post *</Label>
              <Input id="pf-email" data-testid="profile-email-input" type="email" value={form.email} onChange={set("email")} placeholder="anna@mail.se" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="pf-phone">Telefon</Label>
              <Input id="pf-phone" data-testid="profile-phone-input" value={form.phone} onChange={set("phone")} placeholder="070-123 45 67" />
            </div>
          </div>

          <Button
            onClick={save}
            data-testid="profile-form-save-button"
            className="w-full rounded-xl bg-emerald-600 hover:bg-emerald-700"
          >
            Spara profil
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
